export const getRecentPosts = (state) => state.recentPosts || [];
